<div class="web-login-wrapper">
	<div class="web-login-left">
		<div class="logo-container">
			<img src="assets/images/Logo-KeFirma.png" alt="KeFirma Logo" />
		</div>
		<div class="web-login-card">

			<div class="mb-4">
				<div class="titolo mb-2" style="font-size: 1.5rem; font-weight: 600; color: #2C3E50;">Recupero password</div>
				<div class="sottotitolo" style="color: #6c757d; font-size: 0.95rem;">Inserire lo username e seguire le procedure per il recupero della password dell'account.</div>
			</div>

			<form (ngSubmit)="resetPassword()" #resetForm="ngForm">
				<div class="form-group mb-4">
					<label for="username">Username</label>
					<div class="input-wrapper">
						<input type="email" id="username" name="username" [ngModel]="username()" (ngModelChange)="username.set($event)" placeholder="test@mail.com" required autocomplete="username" />
					</div>
				</div>

				@if (success()) {
					<div class="d-flex align-items-start gap-2 p-3 mb-3 rounded-3" style="background:#E9F7EF;">
						<i class="bi bi-check-circle-fill icona-success"></i>
						<span class="testo-success">Email inviata! Controlla la tua casella di posta.</span>
					</div>
				}

				@if (error()) {
					<div class="d-flex align-items-start gap-2 p-3 mb-3 rounded-3" style="background:#FDEDEC; color: #E74C3C;">
						<i class="bi bi-exclamation-circle-fill icona-errore"></i>
						<span class="testo-errore">{{ errorMessage() || 'Si è verificato un errore. Riprova.' }}</span>
					</div>
				}

				<button type="submit" class="btn-login" [disabled]="loading() || success()">
					@if (loading()) {
						<span class="spinner-border spinner-border-sm me-2"></span>
					}
					<span>PROSEGUI</span>
				</button>

				<a href="javascript:void(0)" (click)="goToLogin()" class="forgot-password text-center w-100 d-block mt-3" style="text-decoration: none;">
					<i class="bi bi-arrow-left"></i> Torna alla Login
				</a>
			</form>
		</div>
	</div>

	<div class="web-login-right">
		<div class="illustration-container">
			<img src="assets/images/Kefirma-Solutions.png" alt="KeFirma Illustration" />
		</div>
	</div>
</div>
